import { render, staticRenderFns } from "./footerModelOne.vue?vue&type=template&id=c9ccf706&"
import script from "./footerModelOne.vue?vue&type=script&lang=js&"
export * from "./footerModelOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports